/*
  EditorView
  The form and document editor where forms are created and documents are mapped
*/

import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { FormLayoutService } from '@app/state/form-layout';
import { ID } from '@datorama/akita';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'fl-view-document',
  styleUrls: ['./view-document.component.scss'],
  templateUrl: './view-document.component.html'
})
export class ViewDocumentComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    public documentService: DocumentService,
    private formLayoutService: FormLayoutService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Flow');
    this.activatedRoute.params.subscribe({
      next: (params) => {
        let id: ID = params.id;
        this.documentService.getDocument$(id, {
          success: () => {
            let { title }: { title: string } = this.documentService.document;
            this.formLayoutService.setAllAttributes({ controls: [], title });
            this.titleService.setTitle(`${title} | Flow`);
          }
        });
      }
    });
  }
}
